var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "cog-choice-image-container",
      class: { "is-loading": !_vm.isLoaded && !_vm.option.svg }
    },
    [
      _vm.option.svg
        ? _c("c-generated-avatar", { attrs: { svg: _vm.option.svg } })
        : _c("img", {
            ref: "image",
            class: _vm.getClasses,
            attrs: {
              srcset: !_vm.isSvgFileType ? _vm.getSrcSet : null,
              src: _vm.getSrc,
              alt: _vm.option.label || _vm.option.displayValue,
              width: _vm.dimensions.width,
              height: _vm.dimensions.height,
              loading: "lazy"
            },
            on: { load: _vm.handleLoad }
          })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }